// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-l_hf","advertDetailService__price":"c-l_hg"};